class GiftWrappingComponent extends HTMLElement {
    constructor() {
        super();
        this.cartDrawer = document.querySelector("m-cart-drawer");
        this.giftWrapId = this.dataset.giftWrapId;
        this.giftWrapping = this.dataset.giftWrapping;
        this.cartItemsSize = parseInt(this.getAttribute("cart-items-size"));
        this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart"));
        this.itemsInCart = parseInt(this.getAttribute("items-in-cart"));
        this.loadingIcon = this.querySelector(".m-gift-wrapping--loading");
        this.cart = document.querySelector("m-cart-drawer");

        // Toggle gift wrapping based on checkbox
        this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener("change", (event) => {
            if (event.target.checked) {
                this.setGiftWrapping();
            } else {
                this.removeGiftWrapping();
            }
        });

        // Initial logic for gift wrapping
        if (
            !this.cartDrawer &&
            (
                (this.cartItemsSize === 1 && this.giftWrapsInCart > 0) ||
                (this.giftWrapsInCart > 0 && this.giftWrapsInCart !== 1) || // Ensure only 1 gift wrap is allowed
                (this.giftWrapsInCart > 0 && this.giftWrapping === "false") ||
                (this.giftWrapsInCart === 0 && this.giftWrapping === "true")
            )
        ) {
            this.setGiftWrapping();
        }
    }

    setGiftWrapping() {
        if (this.giftWrapsInCart > 0) {
            // Prevent adding another gift wrap
            console.warn("Gift wrapping already added. Only one allowed.");
            return;
        }

        this.loadingIcon.classList.add("show");
        const requestOptions = {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                Accept: "application/json"
            }),
            body: JSON.stringify({
                updates: {
                    [this.giftWrapId]: 1 // Set the gift wrap quantity to 1
                },
                attributes: {
                    "gift-wrapping": true
                }
            })
        };

        this.updateCart(requestOptions);
    }

    removeGiftWrapping() {
        if (this.giftWrapsInCart === 0) {
            // Prevent removing if no gift wrap is present
            console.warn("No gift wrapping found to remove.");
            return;
        }

        this.loadingIcon.classList.add("show");
        const requestOptions = {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                Accept: "application/json"
            }),
            body: JSON.stringify({
                updates: {
                    [this.giftWrapId]: 0 // Remove the gift wrap item
                },
                attributes: {
                    "gift-wrapping": false,
                    "gift-note": ""
                }
            })
        };

        this.updateCart(requestOptions);
    }

    updateCart(requestOptions) {
        return fetch(`${MinimogSettings.routes.cart_update_url}`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                this.loadingIcon.classList.remove("show");

                // Handle cart UI updates
                if (document.body.classList.contains("template-cart")) {
                    window.location.href = MinimogSettings.routes.cart;
                } else if (this.cartDrawer) {
                    this.cart.onCartDrawerUpdate();
                    this.cartDrawer.classList.toggle("m-cart--empty", data.item_count === 0);
                    MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, data);
                }
            })
            .catch((error) => {
                console.error("Error updating cart:", error);
            });
    }
}

customElements.define("m-gift-wrapping-component", GiftWrappingComponent);
